import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router";
import { colors, glyphs, frames, decors } from "../../../Styles";
import { PageHeader, CardNumberDisplay, LfSystemControls } from "../../../Components";
import { Graph_QL, useSystem, useOldSection } from "../../../Services";
import { useAppSelector } from "../../../Store";
import { CardNumberDisplayList, glyph } from "../../../Components/BaseComponents/cardNumberDisplay";
import { selectLocationsBySystem } from "../../../Services/Agrisys_GqlDataCaller/SectionsCalls/locationSlice";
import { isEqual } from "lodash";
import { selectSectionsBySystem } from "../../../Services/Agrisys_GqlDataCaller/SectionsCalls/sectionsSlice";
import { useSystemInfoById } from "../../../Services/Agrisys_GqlDataCaller/SystemCalls/systemSlice";

export default function FW_FreedaLF() {
  const { t } = useTranslation();
  const focus_view = true;

  const { systemId: urlSystemId } = useParams(); // TODO routing changes in order to get a correct system info
  const location = useLocation();
  const systemId = useMemo(
    () => (urlSystemId ? +urlSystemId : location?.state?.selected),
    [urlSystemId, location]
  );

  // Get System Name for Header
  const { entity: system } = useSystemInfoById(systemId);
  const sections = useAppSelector((state) => selectSectionsBySystem(state, systemId), isEqual);
  const locations = useAppSelector((state) => selectLocationsBySystem(state, [systemId]), isEqual);

  const CardDisplayCompnent = useMemo(() => (
    <CardNumberDisplayList
      focus_view
      values={[ sections.length, locations.length, locations.flatMap(loc => loc.animals).length]}
      units={[
        t("locationFeederPages.locationFeeder.sections", { defaultValue: "Sections" }),
        t("locationFeederPages.locationFeeder.pens", { defaultValue: "Pens" }),
        t("locationFeederPages.locationFeeder.animals", { defaultValue: "Animals" })
      ]}
      glyphs={[
        glyph(<img alt="enhancer" src={decors.def_bg} style={{ width: "440px", opacity: "0.1", transform: "scaleX(-1)" }} />, -33, undefined, undefined, 0),
        glyph(<img alt="enhancer" src={decors.def_bg} style={{ width: "440px", opacity: "0.1", transform: "scaleX(-1)" }} />, -33, 0, undefined, undefined),
        glyph(<img alt="enhancer" src={decors.def_bg} style={{ width: "440px", opacity: "0.1", transform: "scaleX(-1)" }} />, undefined, undefined, -3, 0)
      ]}
    />
  ), [t, locations])

  return(
    <frames.Page_inner_focus_view>
        <PageHeader topHeader={system?.name} />
      
      <frames._page_inner_content_scroll>
        <div style={{display: "flex", flexDirection: "column", gap: "20px", margin: "0 auto", width: "100%", alignItems: "center", justifyContent: "center"}}>
          {CardDisplayCompnent}
          <LfSystemControls systemId={systemId} focus_view/>
        </div>
      </frames._page_inner_content_scroll>
    </frames.Page_inner_focus_view>
  )
}